import { GoToAccountSettingsCTA } from "./ctas";
export var WhatIsEoriIA = function WhatIsEoriIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_IS_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var WHAT_IS_EORI = function WHAT_IS_EORI(strictLocalize) {
  return strictLocalize({
    id: "J4Rz7Z",
    defaultMessage: [{
      "type": 0,
      "value": "O que é um número EORI?"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "VAG9Vi",
    defaultMessage: [{
      "type": 0,
      "value": "O número de \"Registo e Identificação dos Operadores Económicos\" (com a sigla inglesa EORI) é um número único utilizado pelas empresas para se identificarem junto das autoridades aduaneiras nas declarações aduaneiras e noutros documentos de importação. Ter um número EORI ajuda a evitar potenciais atrasos e taxas de armazenamento caso as encomendas não possam ser processadas pela alfândega em tempo útil. Por conseguinte, recomendamos que obtenha um número EORI se estiver a importar produtos de outro país. Pode introduzir o seu número EORI na secção \"Informações fiscais e de importação\" no separador O meu perfil da página Definições de conta."
    }]
  });
};